import React, { memo } from 'react';
import {
  StyledAlert,
  StyledErrorItem,
  StyledErrorList,
  StyledErrorIcon,
} from './styles';

export interface ValidationErrorsProps {
  errors: string[];
}

/**
 * ValidationErrors
 */

const ErrorMessages: React.FC<{ errors: string[] }> = ({ errors }) => {
  return (
    <StyledErrorList>
      {errors.map((error, idx) => (
        <StyledErrorItem key={`${idx}-${error}`}>
          <StyledErrorIcon />
          {error}
        </StyledErrorItem>
      ))}
    </StyledErrorList>
  );
};

export const ValidationErrors: React.FC<ValidationErrorsProps> = ({
  errors,
}) => {
  return (
    <StyledAlert type={'error'} message={<ErrorMessages errors={errors} />} />
  );
};

export default memo(ValidationErrors);
